import { isOrderRefusalBody } from 'modules/api/order';

export const ORDER_REFUSAL_NOT_IN_PLAN = 'not-in-plan';
export const ORDER_REFUSAL_GENERIC = 'generic';

// BBA `modules/order/model.js` re-order guard:
// 'Cannot create re-order: book no longer in customer package'.
const NOT_IN_PLAN_MESSAGE = /no longer in customer package/i;

/**
 * The BBA refusal body inside a failed order call. The axios instance (and
 * `modules/api/order`) reject with the response (`{ data: body }`); the redux
 * order saga keeps `response.data` (the body itself).
 */
const getRefusalBody = (failure) => {
  if (isOrderRefusalBody(failure?.data)) {
    return failure.data;
  }
  return isOrderRefusalBody(failure) ? failure : null;
};

/**
 * Which refusal copy a failed order shows. Only the "no longer in customer
 * package" refusal has its own copy; every other failure, including network
 * errors, is generic. The raw BBA message is never shown.
 */
export const getOrderRefusalKind = (failure) => {
  const message = getRefusalBody(failure)?.message;
  if (typeof message === 'string' && NOT_IN_PLAN_MESSAGE.test(message)) {
    return ORDER_REFUSAL_NOT_IN_PLAN;
  }
  return ORDER_REFUSAL_GENERIC;
};

/**
 * What the confirmation needs from an accepted BBA order (`data` of the
 * `POST /order` body). `approval.required` is true for 50 or more copies:
 * nothing prints until the member approves by e-mail.
 */
export const toPlacedOrder = (orderData, fallbackQuantity) => ({
  orderId: orderData?.orderId ?? null,
  quantity: orderData?.quantity ?? fallbackQuantity ?? null,
  approvalRequired: orderData?.approval?.required === true,
});

/**
 * False only when BBA says the ordered book is out of the member's package.
 * `allowReorder` on `GET /order` rows is computed from the same package list
 * the BBA re-order guard checks; a row without the field stays orderable.
 */
export const canReorder = (orderData) => orderData?.allowReorder !== false;
